import Vue from 'vue';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import VueRouter from 'vue-router';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import gestionErreur from '@/services/general/gestionErreur';
import { isValidLat, isValidLng } from '@/services/general/gestionLatLng';
import getBounds from '@/services/general/getBounds';
import { ServerTable, ClientTable } from 'vue-tables-2';
import './assets/style/app.scss';
import * as translate from './i18n/translate';
import initTranslate from './i18n/serviceTranslate';
import i18n from './i18n';
import Root from './Root';
import store from './store/store';
import router from './router/index';
import { dateParser, LISTE_JOURS, LISTE_MOIS, JOUR_DEBUT_SEMAINE } from './configuration/datePickerConf';

Vue.use(VueRouter);
Vue.use(ClientTable, {}, false, 'bulma', 'default');
Vue.use(ServerTable, {}, false, 'bulma', 'default');
Vue.use(Buefy, {
  defaultDayNames: LISTE_JOURS,
  defaultMonthNames: LISTE_MOIS,
  defaultFirstDayOfWeek: JOUR_DEBUT_SEMAINE,
  defaultDateParser: date => dateParser(date),
  defaultDateFormatter: date => date.toLocaleDateString(),
});

const messages = translate.TRANSLATE;
if (process.env.NODE_ENV === 'development') {
  initTranslate(messages.fr);
}

Vue.component('GmapCluster', GmapCluster);

Vue.mixin({
  methods: {
    isValidLatLng: (lat, lng) => isValidLat(lat) && isValidLng(lng),
    getBounds: () => getBounds(),
  },
});

Vue.config.errorHandler = (e) => {
  gestionErreur('Erreur interne à l\'application', e);
};
window.onerror = (message, source, line, column, e) => {
  gestionErreur('Erreur interne à l\'application', e);
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(Root),
});



// WEBPACK FOOTER //
// ./src/main.js